/**
 * Generate initials from a full name.
 * Strategy: first letter of first name + first two letters of last name
 * e.g. "Martin Bentzen" → "MBe", "Anna K" → "AK", "Madonna" → "Ma"
 * This maximises uniqueness while staying readable.
 */
export function getInitials(name: string | null | undefined): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) {
    // Single name: first two letters
    return parts[0].slice(0, 2).toUpperCase();
  }
  const first = parts[0][0].toUpperCase();
  const last = parts[parts.length - 1].slice(0, 2);
  // Capitalise first letter of last, lowercase second
  const lastInitials = last[0].toUpperCase() + (last[1] ?? '').toLowerCase();
  return first + lastInitials;
}
